<!--
Author: TangChen
Date: 2018-09-17
Desc: 用户信息展示组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-modify-info bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">
                    个人中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <user-info />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userInfo from "@/components/acctInfo/userInfo";
export default {
    name: "ModifyInfo",
    components: {
        userInfo
    },
    mixins: [mixin],
    data () {
        return {
        };
    },
    methods: {
    }
};
</script>
